import type { ReactNode } from "react";
import { csvFilename, downloadCsv, toCsv } from "../lib/csv";
import { Button } from "./Button";
import { STRINGS } from "./strings";

/* The parts a record is laid out from. The same shape the records had before
 * the overhaul (src/components/Panel.tsx), kept so a record moves onto the
 * shared layer with few edits. */

/** A labelled value. */
export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="field">
      <div className="field-label">{label}</div>
      <div>{children}</div>
    </div>
  );
}

/** A section of a record, with its own heading so the record reads in order,
 *  and a CSV of what it shows, because anything on screen can be taken away. */
export function Section({ title, count, download, children }: {
  title: string;
  count?: number | null;
  download?: { name: string; columns: string[]; rows: readonly unknown[] };
  children: ReactNode;
}) {
  return (
    <section className="panel-section">
      <h3>
        {title}
        {count === null || count === undefined ? null : (
          <span className="muted ui-section-count"> ({count.toLocaleString()})</span>
        )}
        {download && download.rows.length ? (
          <Button
            kind="link" size="compact-xs" className="ui-section-csv"
            onClick={() => downloadCsv(
              csvFilename(download.name),
              toCsv(download.columns, download.rows as Record<string, unknown>[]),
            )}
          >
            {STRINGS.csv}
          </Button>
        ) : null}
      </h3>
      {children}
    </section>
  );
}
